"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var Mobilefilters = function Mobilefilters(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "ic_menu_24px-mobilefilters" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.5,6.5h17C20.8,6.5,21,6.7,21,7v0.8c0,0.3-0.2,0.5-0.5,0.5h-17C3.2,8.3,3,8.1,3,7.8V7C3,6.7,3.2,6.5,3.5,6.5z",
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.5,11.1h11c0.3,0,0.5,0.2,0.5,0.5v0.8c0,0.3-0.2,0.5-0.5,0.5h-11c-0.3,0-0.5-0.2-0.5-0.5v-0.8C6,11.3,6.2,11.1,6.5,11.1z ",
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.5,15.7h5c0.3,0,0.5,0.2,0.5,0.5V17c0,0.3-0.2,0.5-0.5,0.5h-5C9.2,17.5,9,17.3,9,17v-0.8C9,15.9,9.2,15.7,9.5,15.7z",
    fill: "inherit"
  })));
};

Mobilefilters.propTypes = propTypes;
var _default = Mobilefilters;
exports["default"] = _default;